import React from 'react'
import { MDBContainer, MDBRow, MDBCol, MDBIcon } from 'mdbreact'
import Fab from '@material-ui/core/Fab';
//graphql
import { useQuery } from '@apollo/react-hooks';
import SOCIALS_QUERY from '../queries/socials'
import Error from './loaders/Error';

const SocialLinks = () => {
    const { data, loading, error } = useQuery(SOCIALS_QUERY)

    if(loading) return <p>loading</p>
    if(error) return <Error/>

    const { facebook, instagram, pinterest, twitter } = data.socialAccount

    return (
        <>
        <MDBContainer className="landing-page-socials my-5 pb-5">
                <MDBRow className="text-center justify-content-center">
                    <MDBCol>
                        <a href={facebook}>
                            <Fab className="mt-2 mb-2" color="primary" aria-label="add">
                                <MDBIcon fab icon="facebook-f"/>
                            </Fab>
                        </a>
                    </MDBCol>
                    <MDBCol>
                        <a href={pinterest}>
                            <Fab className="mt-2 mb-2" color='secondary' aria-label="pinterest">
                                <MDBIcon fab icon="pinterest-p"/>
                            </Fab>
                        </a>
                    </MDBCol>
                    <MDBCol>
                        <a href={instagram}>
                            <Fab className="mt-2 mb-2" style={{ background: 'deep-orange-text' }} aria-label="instagram">
                                <MDBIcon fab icon="instagram deep-orange-text" />                    
                            </Fab>
                        </a>
                    </MDBCol>
                    <MDBCol>
                        <a href={twitter}>
                            <Fab className="mt-2 mb-2" style={{ background: `#33b5e5` }} aria-label="twitter">
                                <MDBIcon fab className="white-text" icon="twitter" />
                            </Fab>
                        </a>
                    </MDBCol>
                </MDBRow>
            </MDBContainer> 
            <MDBContainer className="landing-page-socials-mobile mt-5 mb-5">
                <MDBRow className="text-center justify-content-center mx-4 mb-2">
                    <MDBCol size="3">
                        <a href={facebook}>
                            <Fab className="mt-2 mb-2" color="primary" aria-label="add">
                                <MDBIcon fab icon="facebook-f"/>
                            </Fab>
                        </a>
                    </MDBCol>
                    <MDBCol size="3">
                        <a href={pinterest}>
                            <Fab className="mt-2 mb-2" color='secondary' aria-label="pinterest">
                                <MDBIcon fab icon="pinterest-p"/>
                            </Fab>
                        </a>
                    </MDBCol>
                    <MDBCol size="3">
                        <a href={instagram}>
                            <Fab className="mt-2 mb-2" style={{ background: 'deep-orange-text' }} aria-label="instagram">
                                <MDBIcon fab icon="instagram deep-orange-text" />                    
                            </Fab>
                        </a>
                    </MDBCol>
                    <MDBCol size="3">
                        <a href={twitter}>
                            <Fab className="mt-2 mb-2" style={{ background: `#33b5e5` }} aria-label="twitter">
                                <MDBIcon fab className="white-text" icon="twitter" />
                            </Fab>
                        </a>
                    </MDBCol>
                </MDBRow>
            </MDBContainer> 
        </>
    )
}

export default SocialLinks
